type TableSkeletonProps = {
  rows: number;
  columns: number;
};

export function TableSkeleton({ rows, columns }: TableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={`skeleton-row-${rowIndex}`} className="animate-pulse">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td
              key={`skeleton-cell-${rowIndex}-${colIndex}`}
              className="px-4 py-4 border-b border-b-[#E9E9EB]"
            >
              <div className="w-full h-4 bg-gray-300 rounded-md"></div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
